import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "download",
  "use": "download-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"download\"><title>download</title><path d=\"M15.564 10.036h-1.455a.313.313 0 0 0-.291.291v3.345H2.182v-3.345c0-.291-.145-.291-.291-.291H.436c-.291 0-.436.145-.436.291v5.236c0 .291.145.436.436.436h15.273c.291 0 .436-.145.436-.436v-5.236c-.145-.145-.291-.291-.582-.291zm-3.055-5.091H9.164V.436C9.164.291 9.019 0 8.728 0H7.273c-.291 0-.436.291-.436.436v4.509H3.492l4.509 6.109 4.509-6.109z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/download.svg
// module id = 25
// module chunks = 0